import React, { useEffect, useState } from "react";
import { Package, ShoppingCart, DollarSign, MessageSquare } from "lucide-react";
import { api, fmtCAD } from "@/lib/api";

const Stat = ({ icon: Icon, label, value, testid }) => (
  <div className="bg-white border border-gray-200 p-6" data-testid={testid}>
    <div className="flex items-center justify-between">
      <span className="text-sm text-gray-500">{label}</span>
      <Icon size={20} className="text-sapphire" />
    </div>
    <p className="font-heading text-3xl font-extrabold mt-3">{value}</p>
  </div>
);

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <p className="text-gray-400">Chargement…</p>;

  return (
    <div>
      <h1 className="font-heading text-3xl font-extrabold mb-8">Tableau de bord</h1>
      <div className="grid gap-4 md:grid-cols-4 mb-10">
        <Stat icon={DollarSign} label="Revenus (payés)" value={fmtCAD(s.revenue)} testid="stat-revenue" />
        <Stat icon={ShoppingCart} label="Commandes payées" value={`${s.paid_orders}/${s.total_orders}`} testid="stat-orders" />
        <Stat icon={Package} label="Produits" value={s.total_products} testid="stat-products" />
        <Stat icon={MessageSquare} label="Messages" value={s.leads} testid="stat-leads" />
      </div>
      <div className="bg-white border border-gray-200">
        <h2 className="font-heading text-xl font-bold p-6 border-b border-gray-200">Commandes récentes</h2>
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left text-gray-500"><tr>
            <th className="p-4">Commande</th><th className="p-4">Client</th><th className="p-4">Total</th><th className="p-4">Statut</th>
          </tr></thead>
          <tbody>
            {s.recent_orders.map((o) => (
              <tr key={o.order_number} className="border-t border-gray-100">
                <td className="p-4 font-medium">{o.order_number}</td>
                <td className="p-4">{o.customer?.name}</td>
                <td className="p-4">{fmtCAD(o.subtotal)}</td>
                <td className="p-4"><span className={`px-2 py-1 text-xs font-medium ${o.payment_status === "paid" ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>{o.payment_status === "paid" ? "Payé" : "En attente"}</span></td>
              </tr>
            ))}
            {s.recent_orders.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-gray-400">Aucune commande.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
